import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  Typography,
} from "@mui/material";
import { updateShippingCompany } from "../../../services/Admin/ShippingCompanyesApi";

const EditShippingCompanyDialog = ({ open, company = null, onClose, onSuccess }) => {
  const [form, setForm] = useState({ id: null, name: "", address: "", phone: "", email: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (company) {
      setForm({
        id: company.id,
        name: company.name ?? "",
        address: company.address ?? "",
        phone: company.phone ?? "",
        email: company.email ?? "",
      });
      setError("");
    } else {
      setForm({ id: null, name: "", address: "", phone: "", email: "" });
    }
  }, [company, open]);

  const handleChange = (field) => (e) => setForm((p) => ({ ...p, [field]: e.target.value }));

  const handleSubmit = async () => {
    setError("");
    if (!form.id) {
      setError("company id missing.");
      return;
    }
    if (!form.name) {
      setError("الاسم مطلوب.");
      return;
    }
    setLoading(true);
    try {
await updateShippingCompany(form.id, {
  name: form.name,
  address: form.address,
  phone: form.phone,
  email: form.email,
});
      if (onSuccess) await onSuccess();
      if (onClose) onClose();
    } catch (err) {
      setError(err?.message || "فشل تحديث بيانات شركة الشحن");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={!!open} onClose={() => !loading && onClose && onClose()} fullWidth maxWidth="sm">
      <DialogTitle>تعديل شركة الشحن</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField label="الاسم" value={form.name} onChange={handleChange("name")} fullWidth />
          <TextField label="العنوان" value={form.address} onChange={handleChange("address")} fullWidth />
          <TextField label="الهاتف" value={form.phone} onChange={handleChange("phone")} fullWidth />
          <TextField label="البريد الإلكتروني" value={form.email} onChange={handleChange("email")} fullWidth />
          {error ? <Typography color="error">{error}</Typography> : null}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => !loading && onClose && onClose()}>إلغاء</Button>
        <Button onClick={handleSubmit} disabled={loading} variant="contained">
          {loading ? "جارٍ..." : "حفظ التعديلات"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditShippingCompanyDialog;
